import React from 'react';
import { FormattedMessage } from 'react-intl';
import CustomTable from '../CustomTable/CustomTable';
import OffersListLoaderItem from './OffersListLoaderItem';

const renderLoaderItems = count => {
  const items = [];
  const itemsCount = count > 0 ? count : 5;

  for (let i = 0; i < itemsCount; i++) {
      items.push(<OffersListLoaderItem key={`offers_loader${i}`}/>);
  }

  return items;
};

const OfferListLoader = ({ offersCount, isSearching }) => {
  if (isSearching) return null;

  return (
    <CustomTable className="offers-list" responsive condensed aria-label="Offers">
      <CustomTable.Wrapper>
        <CustomTable.Row>
          <CustomTable.Cell />

          <CustomTable.Cell>
            <FormattedMessage id="offers.table.offer" defaultMessage="Offer" />
          </CustomTable.Cell>

          <CustomTable.Cell>
            <FormattedMessage id="offers.table.targets" defaultMessage="Targets" />
          </CustomTable.Cell>

          <CustomTable.Cell className="text-right">CR</CustomTable.Cell>

          <CustomTable.Cell className="text-right">EPC</CustomTable.Cell>

          <CustomTable.Cell>
            <FormattedMessage id="offers.table.geo" defaultMessage="Geo" />
          </CustomTable.Cell>

          <CustomTable.Cell />
        </CustomTable.Row>
      </CustomTable.Wrapper>

      <CustomTable.Wrapper type="body">
        {renderLoaderItems(offersCount)}
      </CustomTable.Wrapper>
    </CustomTable>
  );
};

export default OfferListLoader;
